import React from 'react';

import { localize } from 'wanderu-i18n';
import type { I18nMoneyFunction } from 'wanderu-i18n';

import { CurrencyMismatch } from '../../CurrencyMismatch';
import { LineItem } from '../../LineItem';
import {
    useFormattedTripPricingSelector,
} from '../../hooks';
import { Fees } from '../Fees';

import styles from './TripLegPrice.scss';

import type { TripLegItems } from '../../types';
import type { TFunction } from 'i18next';

interface TripLegPriceProps extends TripLegItems {
    i18nMoney: I18nMoneyFunction;
    t: TFunction;
}

function TripLegPrice(props: TripLegPriceProps) {
    const {
        i18nMoney,
        t,
        tripId,
    } = props;

    const {
        basePrice,
        fees,
        taxes,
    } = useFormattedTripPricingSelector({ i18nMoney, tripId });

    return (
        <div className={styles.container}>
            <LineItem
                leftCol={t<string>('ticket-s')}
                rightCol={basePrice}
            />
            {fees.length > 0 && (
                <Fees fees={fees} />
            )}
            {taxes && (
                <LineItem
                    leftCol={t<string>('taxes')}
                    rightCol={taxes}
                />
            )}

            <CurrencyMismatch tripId={tripId} />
        </div>
    );
}

export { TripLegPrice };
export default localize(TripLegPrice, ['i18nMoney', 't'], 'baseApp');
